import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { ErrorNote, useLoad } from './ui';

const hourLabel = (h: number) => `${h % 12 === 0 ? 12 : h % 12}:00 ${h < 12 ? 'AM' : 'PM'}`;
const toList = (s: string) => s.split(/[\s,;]+/).map((x) => x.trim()).filter(Boolean);

// When the morning reports are made, and who gets them by email. Shared by the morning summary and the fraud watch.
export default function AgentSettings({ which }: { which: 'brief' | 'fraud' }) {
  const s = useLoad(() => api<any>('/api/briefs/settings'), []);
  const [f, setF] = useState<any>(null);
  const [err, setErr] = useState<unknown>(null);
  const [saved, setSaved] = useState(false);
  useEffect(() => { if (s.data) setF({ ...s.data, briefText: s.data.briefEmails.join(', '), fraudText: s.data.fraudEmails.join(', ') }); }, [s.data]);
  if (!f) return <ErrorNote error={s.error} />;
  const enabledKey = which === 'brief' ? 'briefEnabled' : 'fraudEnabled';
  const textKey = which === 'brief' ? 'briefText' : 'fraudText';
  return (
    <div className="panel"><div className="panel-head"><h2>Settings</h2></div><div className="panel-body stack">
      <ErrorNote error={err} />
      {saved && <div className="notice good">Saved.</div>}
      <div className="field-row">
        <label>Make it every morning at<select value={f.runHour} onChange={(e) => setF({ ...f, runHour: Number(e.target.value) })}>{Array.from({ length: 12 }, (_, i) => i + 3).map((h) => <option key={h} value={h}>{hourLabel(h)}</option>)}</select></label>
        <label>Email it to (separate with commas)<input value={f[textKey]} onChange={(e) => setF({ ...f, [textKey]: e.target.value })} placeholder="you@example.com" /></label>
      </div>
      <label className="row" style={{ display: 'flex', fontWeight: 500, color: 'var(--ink)', gap: 6 }}><input type="checkbox" style={{ width: 'auto', minHeight: 0 }} checked={f[enabledKey]} onChange={(e) => setF({ ...f, [enabledKey]: e.target.checked })} /> Make it every morning</label>
      <div><button className="primary" onClick={async () => {
        setErr(null); setSaved(false);
        try { await api('/api/briefs/settings', { method: 'PUT', body: { runHour: f.runHour, briefEnabled: f.briefEnabled, fraudEnabled: f.fraudEnabled, briefEmails: toList(f.briefText), fraudEmails: toList(f.fraudText) } }); setSaved(true); s.reload(); } catch (e) { setErr(e); }
      }}>Save settings</button></div>
      {!f.aiAvailable && <p className="faint">The AI is not turned on for this server yet, so the written reading is a plain version made from the numbers. Everything else works the same.</p>}
    </div></div>
  );
}
